
import { DELETE_ID, USERCHAT_ID } from "./userChatIdAction";

const INITIAL_STATE = {
  users: []
};

const userChatIdReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERCHAT_ID: {
      const index = state.users.findIndex(
        item => item.id === action.payload.id
      );

      // existe → actualizar
      if (index >= 0) {
          
      return {
       ...state,
       users: state.users.map((user, i) =>
       user.id === action.payload.id
        ? {
            ...user,
            messages: [...user.messages, ...action.payload.messages]
          }
        : user
       ),
      };
      } 
     
      return {
    
        ...state,
        users: [...state.users, action.payload],

        
      };
    }


    case DELETE_ID:
         return {
        ...state,
      users: state.users.filter(user => user.id !== action.payload)
     }  
    



    default:
      return state;
  }
};

export default userChatIdReducer;
